import React from 'react';
import { Eye, X } from 'lucide-react';

// Labels pour les modules (nom affiché)
export const MODULE_LABELS = {
  // Awin (affiliation)
  awin_results: 'Résultats',
  awin_publishers: 'Éditeurs',
  awin_commission_status: 'Statut des commissions',
  // Google Ads / Microsoft Ads / Facebook Ads
  results: 'Résultats',
  chart: 'Graphique',
  campaigns: 'Campagnes',
  campaign_types: 'Types de campagnes',
  ad_groups: 'Groupes d\'annonces',
  asset_groups: 'Groupes Performance Max',
  networks: 'Réseaux',
  devices: 'Appareils',
  weekdays: 'Jours de la semaine',
  geography: 'Géographie',
  age_ranges: 'Tranches d\'âge',
  gender: 'Genre',
  audiences: 'Audiences',
  topflop_terms: 'Top & Flop Termes',
  topflop_products: 'Top & Flop Produits',
  topflop_categories: 'Top & Flop Catégories',
  topflop_itemgroups: 'Top & Flop Groupes Produits',
  // Microsoft Ads
  msads_insights: 'Analyse Microsoft Ads',
  msads_networks: 'Réseaux Microsoft Ads',
  msads_search_terms: 'Termes de recherche Microsoft Ads',
  // Facebook Ads
  fbads_campaigns: 'Campagnes Facebook',
  fbads_platforms: 'Plateformes Facebook',
  fbads_adsets: 'Ensembles de publicités',
  fbads_ads: 'Annonces Facebook',
  fbads_engagement: 'Engagement',
  fbads_devices: 'Appareils Facebook',
  fbads_weekdays: 'Jours de la semaine Facebook',
  fbads_age: 'Tranches d\'âge Facebook',
  fbads_gender: 'Genre Facebook',
  fbads_placements: 'Placements Facebook',
  // Matomo
  matomo_performance: 'Performance Matomo',
  matomo_channels: 'Canaux Matomo',
  matomo_geography: 'Géographie Matomo',
  matomo_funnel: 'Entonnoir de conversion',
  matomo_events: 'Événements',
  matomo_transitions: 'Transitions de pages',
  // GA4
  ga4_performance: 'Performance Google Analytics',
  ga4_channels: 'Canaux Google Analytics',
  ga4_geography: 'Géographie Google Analytics',
  ga4_devices: 'Appareils Google Analytics',
  ga4_pages: 'Pages Google Analytics',
  ga4_insights: 'Analyse Google Analytics',
  ga4_events: 'Événements Google Analytics',
  ga4_ecommerce_funnel: 'Parcours d\'achat Google Analytics',
  ga4_ecommerce_products: 'Achats e-commerce Google Analytics',
  // Piano Analytics
  piano_performance: 'Performance Piano',
  piano_channels: 'Canaux Piano',
  piano_geography: 'Géographie Piano'
};

/**
 * Modal qui affiche les modules masqués et permet de les restaurer
 *
 * @param {boolean} isOpen - Le modal est-il ouvert
 * @param {function} onClose - Callback pour fermer le modal
 * @param {string[]} hiddenModules - Liste des IDs de modules masqués
 * @param {function} onRestoreModule - Callback pour restaurer un module (moduleId)
 */
const HiddenModulesModal = ({ isOpen, onClose, hiddenModules = [], onRestoreModule }) => {
  if (!isOpen) return null;

  const handleRestoreAll = () => {
    hiddenModules.forEach(moduleId => {
      onRestoreModule(moduleId);
    });
    onClose();
  };

  const handleRestore = (moduleId) => {
    onRestoreModule(moduleId);
    // Fermer le modal si c'était le dernier module
    if (hiddenModules.length === 1) {
      onClose();
    }
  };

  return (
    <div className="hidden-modules-modal-overlay" onClick={onClose}>
      <div className="hidden-modules-modal" onClick={(e) => e.stopPropagation()}>
        <div className="hidden-modules-modal-header">
          <h3>Modules masqués ({hiddenModules.length})</h3>
          <button className="hidden-modules-modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="hidden-modules-modal-content">
          {hiddenModules.length === 0 ? (
            <p className="hidden-modules-empty">Aucun module masqué</p>
          ) : (
            <>
              <p className="hidden-modules-description">
                Ces modules sont masqués pour le client. Cliquez sur un module pour le réafficher.
              </p>
              <div className="hidden-modules-grid">
                {hiddenModules.map(moduleId => (
                  <button
                    key={moduleId}
                    className="hidden-module-item"
                    onClick={() => handleRestore(moduleId)}
                    title={`Afficher ${MODULE_LABELS[moduleId] || moduleId}`}
                  >
                    <Eye size={16} />
                    <span>{MODULE_LABELS[moduleId] || moduleId}</span>
                  </button>
                ))}
              </div>
              {hiddenModules.length > 1 && (
                <button className="hidden-modules-restore-all" onClick={handleRestoreAll}>
                  Tout afficher
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default HiddenModulesModal;
